import { render, staticRenderFns } from "./ColorPickerField.vue?vue&type=template&id=cb8f4a16&scoped=true"
import script from "./ColorPickerField.vue?vue&type=script&lang=js"
export * from "./ColorPickerField.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerField.vue?vue&type=style&index=0&id=cb8f4a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8f4a16",
  null
  
)

export default component.exports